import * as Articles from "./Articles/index.js";
import * as ViewModels from "./ViewModels/index.js";
import * as Submarkets from "./Submarkets/index.js";
/** CoStar.Api.AptsContentSub.TopSchoolMatchType */
export var TopSchoolMatchType;
(function (TopSchoolMatchType) {
    TopSchoolMatchType[TopSchoolMatchType["Unknown"] = 0] = "Unknown";
    TopSchoolMatchType[TopSchoolMatchType["City"] = 3] = "City";
})(TopSchoolMatchType || (TopSchoolMatchType = {}));
/** CoStar.Api.AptsContentSub.ArticleSectionType */
export var ArticleSectionType;
(function (ArticleSectionType) {
    ArticleSectionType[ArticleSectionType["None"] = 0] = "None";
    ArticleSectionType[ArticleSectionType["Overview"] = 1] = "Overview";
    ArticleSectionType[ArticleSectionType["Restaurants"] = 2] = "Restaurants";
    ArticleSectionType[ArticleSectionType["History"] = 3] = "History";
    ArticleSectionType[ArticleSectionType["Transportation"] = 4] = "Transportation";
    ArticleSectionType[ArticleSectionType["Cost"] = 5] = "Cost";
    ArticleSectionType[ArticleSectionType["Shopping"] = 6] = "Shopping";
    ArticleSectionType[ArticleSectionType["Parks"] = 7] = "Parks";
    ArticleSectionType[ArticleSectionType["Highlights"] = 8] = "Highlights";
    ArticleSectionType[ArticleSectionType["Headline"] = 9] = "Headline";
    ArticleSectionType[ArticleSectionType["Tags"] = 10] = "Tags";
})(ArticleSectionType || (ArticleSectionType = {}));
export { Articles, ViewModels, Submarkets };
